import { render, staticRenderFns } from "./AB.vue?vue&type=template&id=109b375b&scoped=true"
import script from "./AB.vue?vue&type=script&lang=js"
export * from "./AB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109b375b",
  null
  
)

export default component.exports